import CryptoJS from 'crypto-js'
const DAYSTH = ['วันอาทิตย์', 'วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์']
const DAYSEN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const SHORTDAYSTH = ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.']
const SHORTDAYSEN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTHSTH = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
const MONTHSEN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const SHORTMONTHSTH = ['ม.ค.', 'ก.พ', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค']
const SHORTMONTHSEN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const SHORTNANE = ['อ.1', 'อ.2', 'อ.3', 'ป.1', 'ป.2', 'ป.3', 'ป.4', 'ป.5', 'ป.6', 'ม.1', 'ม.2', 'ม.3', 'ม.4', 'ม.5', 'ม.6']
const FULLNAME = [
    'อนุบาล 1', 'อนุบาล 2', 'อนุบาล 3', 'ประถมศึกษาปีที่ 1', 'ประถมศึกษาปีที่ 2', 'ประถมศึกษาปีที่ 3', 'ประถมศึกษาปีที่ 4', 'ประถมศึกษาปีที่ 5',
    'ประถมศึกษาปีที่ 6', 'มัธยมศึกษาปีที่ 1', 'มัธยมศึกษาปีที่ 2', 'มัธยมศึกษาปีที่ 3', 'มัธยมศึกษาปีที่ 4', 'มัธยมศึกษาปีที่ 5', 'มัธยมศึกษาปีที่ 6'
]
const KINDERGARTEN = [99, 98, 97]

const transactionStatus = () => {
    return {
        WAITING: 'WAITING',
        DONE: 'DONE',
        UNDONE: 'UNDONE'
    }
}

const months = (currentLang) => {
    let MONTHS = MONTHSEN
    if (currentLang === 'th') {
        MONTHS = MONTHSTH
    }
    return MONTHS
}

const dayList = (currentLang, cutPrefix = false) => {
    if (currentLang === 'th') {
        return cutPrefix ? DAYSTH.map(d => d.slice(3)) : DAYSTH
    }
    return DAYSEN
}

const getDay = (weekDay, currentLang, cutPrefix = false) => {
    if (!weekDay) {
        return null
    }
    weekDay -= 1
    if (currentLang === 'th') {
        return cutPrefix ? DAYSTH[weekDay].slice(3) : DAYSTH[weekDay]
    }
    return DAYSEN[weekDay]
}

const weekDayToString = (weekDay, currentLang) => {
    if (currentLang === 'th') {
        return DAYSTH[weekDay - 1]
    } else {
        return DAYSEN[weekDay - 1]
    }
}

const weekDayToShortString = (weekDay, currentLang) => {
    // อา.
    if (currentLang === 'th') {
        return SHORTDAYSTH[weekDay - 1]
    } else {
        return SHORTDAYSEN[weekDay - 1]
    }
}

const dateToShortDateString = (dateInput, currentLang) => {
    // 30 ส.ค. 66
    const date = new Date(dateInput)
    if (!date) {
        return null
    }
    let MONTHS = SHORTMONTHSEN
    if (currentLang === 'th') {
        MONTHS = SHORTMONTHSTH
    }
    const month = date.getMonth()
    const monthString = MONTHS[month]

    let year = date.getFullYear()

    if (currentLang === 'th') {
        year += 543
    }

    const yearStr = year.toString()
    const shortYear = yearStr.slice(-2)

    const dateNumber = date.getDate()

    return `${dateNumber} ${monthString} ${shortYear}`
}

const datetimeToShortDateString = (datetimeInput, currentLang) => {
    // 30 ส.ค. 66 8:00 น.
    const datetime = new Date(datetimeInput)
    if (!datetime) {
        return null
    }
    let MONTHS = SHORTMONTHSEN
    if (currentLang === 'th') {
        MONTHS = SHORTMONTHSTH
    }
    const month = datetime.getMonth()
    const monthString = MONTHS[month]

    let year = datetime.getFullYear()

    if (currentLang === 'th') {
        year += 543
    }

    const yearStr = year.toString()
    const shortYear = yearStr.slice(-2)

    const dateNumber = datetime.getDate()

    const hour = datetime.getHours()
    const minute = datetime.getMinutes()

    return `${dateNumber} ${monthString} ${shortYear} ${hour}:${minute} น.`
}

const getShortMonthAndFullYear = (dateInput, currentLang) => {
    const date = new Date(dateInput)
    if (!date) {
        return null
    }
    let MONTHS = SHORTMONTHSEN
    if (currentLang === 'th') {
        MONTHS = SHORTMONTHSTH
    }
    const month = date.getMonth()
    const monthString = MONTHS[month]

    let year = date.getFullYear()

    if (currentLang === 'th') {
        year += 543
    }

    return `${monthString} ${year}`
}

const getFullStudentYear = (year) => {
    let yearString = String
    if (KINDERGARTEN.includes(year)) {
        if (year === 99) {
            yearString = FULLNAME[0]
        } else if (year === 98) {
            yearString = FULLNAME[1]
        } else {
            yearString = FULLNAME[2]
        }
    } else {
        const index = year + 2
        yearString = FULLNAME[index]
    }

    return yearString
}

const getShortStudentYear = (year) => {
    let yearString = String
    if (KINDERGARTEN.includes(year)) {
        if (year === 99) {
            yearString = SHORTNANE[0]
        } else if (year === 98) {
            yearString = SHORTNANE[1]
        } else {
            yearString = SHORTNANE[2]
        }
    } else {
        const index = year + 2
        yearString = SHORTNANE[index]
    }

    return yearString
}

const monthList = (currentLang) => {
    const data = []
    let MONTHS = MONTHSEN
    if (currentLang === 'th') {
        MONTHS = MONTHSTH
    }
    for (let i = 0; i < MONTHS.length; i++) {
        data.push({
            text: MONTHS[i],
            value: i
        })
    }
    return data
}

const encryptECB = (plainText) => {
    try {
        return CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Utf8.parse(process.env.VUE_APP_CRYPTO_SECRET_KEY), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString()
    } catch (e) {
        return null
    }
}

const decryptECB = (cipherText) => {
    try {
        // console.log(process.env.VUE_APP_CRYPTO_SECRET_KEY)

        const bytes = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Utf8.parse(process.env.VUE_APP_CRYPTO_SECRET_KEY), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        })
        return bytes.toString(CryptoJS.enc.Utf8)
    } catch (e) {
        return null
    }
}

const formatBalance = (val) => {
    if (val) {
        return Number(val).toLocaleString('th-TH', { minimumFractionDigits: 2 })
    } else {
        return '0.00'
    }
}

const getDateTimeFormat = (date, format = null) => {
    // 12/11/2023 23:17:43 or 12/11/2023 01:05:03
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    const dayStr = day < 10 ? `0${day}` : day
    const monthStr = month < 10 ? `0${month}` : month
    const hourStr = hour < 10 ? `0${hour}` : hour
    const minuteStr = minute < 10 ? `0${minute}` : minute
    const secondStr = second < 10 ? `0${second}` : second

    if (format === 1) {
        return `${dayStr}/${monthStr}/${year}`
    }
    return `${dayStr}/${monthStr}/${year} ${hourStr}:${minuteStr}:${secondStr}`
}

/**
 * Creates a dynamic script element and appends it to a parent element.
 * @param {string} parentElId - The ID of the parent element where the script will be appended.
 * @param {string} src - The source URL of the script.
 * @param {Object} attrs - Additional attributes to be set on the script element.
 * @param {boolean} async - Indicates whether the script should be loaded asynchronously (default: true).
 * @returns {Promise<void>} - A promise that resolves when the script is loaded successfully, or rejects with an error if the script fails to load.
 */
const createDynamicScriptElement = async (parentElId, src, attrs = {}, async = true) => {
    const script = document.createElement('script')
    script.setAttribute('src', src)
    script.setAttribute('id', 'test1234')
    script.setAttribute('async', async)
    Object.keys(attrs).forEach((key) => {
        script.setAttribute(key, attrs[key])
    })
    const parentEl = document.getElementById(parentElId)
    parentEl.appendChild(script)

    // wait for script to create button then click
    return new Promise((resolve, reject) => {
        script.onload = () => {
            resolve()
        }
        script.onerror = () => {
            reject(new Error('Error loading script'))
        }
    })
}

export default {
    months,
    dayList,
    getDay,
    weekDayToString,
    weekDayToShortString,
    dateToShortDateString,
    datetimeToShortDateString,
    getShortMonthAndFullYear,
    getFullStudentYear,
    getShortStudentYear,
    monthList,
    encryptECB,
    decryptECB,
    formatBalance,
    getDateTimeFormat,
    transactionStatus,
    createDynamicScriptElement
}
